import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import DeleteModal from "../../components/Common/DeleteModal";
import Notification from "../../components/Common/Notification";
import Helpers from "../../helpers/helpers";

import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import { exportMarkettingReport, getMarkettingReport, resetReportAttachmentState } from "../../store/report/actions";
import "./report.css";
import moment from "moment";

const MarketingReport = ({ markettingReportDocument, markettingReportListing, userPermission }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [promotionFilter, setPromotionFilter] = useState(0);
    const [discountFilter, setDiscountFilter] = useState(0);
    const [statusFilter, setStatusFilter] = useState("all");
    const [sort_by, setSortBy] = useState('sales_date');
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [sort, setSorted] = useState("asc")
    const [exportable, setExportable] = useState(false);
    const [viewable, setViewable] = useState(false);

    useEffect(() => {
        let payload = {
            sort: sort_by,
            sort_order: sort,
            status: statusFilter === "all" ? "" : statusFilter,
            type: promotionFilter == 0 ? "" : promotionFilter,
            discount_type: discountFilter == 0 ? "" : discountFilter,
            page: page,
            length: length,
        }
        dispatch(getMarkettingReport(payload))
    }, [promotionFilter, sort, sort_by, statusFilter, discountFilter, length, page]);

    const [content, setContent] = useState({
        open: false,
        title: "",
        msg: "",
        buttonTitle: "",
        action: "",
        id: "",
    })

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const promotionList = [
        { value: "0", label: "All promotion types" },
        { value: "promo_code", label: "Promo code" },
        { value: "voucher", label: "Voucher" },
    ]

    const discountTargetList = [
        { value: "0", label: "All discount targets" },
        { value: "product", label: "Products" },
        { value: "shipping", label: "Shipping" },
    ]

    const statusList = [
        { value: "all", label: "All statuses" },
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
    ]

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("export-reporting") && setExportable(true);
            userPermission?.includes("view-reporting") && setViewable(true);
            !userPermission?.includes("view-reporting") && navigate('/not-authorized');
        }
    }, [userPermission])

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const handleExport = () => {
        let filter = {
            status: statusFilter === "all" ? "" : statusFilter,
            type: promotionFilter == 0 ? "" : promotionFilter,
            discount_type: discountFilter == 0 ? "" : discountFilter,
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setLoading(true);
        if (Object.keys(filter).length === 0) {
            dispatch(exportMarkettingReport({
                sort_by: sort_by, sort_order: sort,
            }));
        } else {
            dispatch(exportMarkettingReport({
                filter: filter, sort_by: sort_by, sort_order: sort,
            }));
        }

    }

    useEffect(() => {
        if (markettingReportDocument?.code === "success") {
            setLoading(false)
            Helpers.handleDownloadExcelFile(markettingReportDocument?.excel_base64, 'marketing_report');
            dispatch(resetReportAttachmentState());
        }

    }, [markettingReportDocument]);

    const resetFilter = () => {
        setPage("1");
        setPromotionFilter(0);
        setDiscountFilter(0);
        setStatusFilter("all");
    }

    const header = [
        {
            Header: "Promotion types",
            columnID: "type",
            accessor: (cellProps) => {
                return (
                    <div>
                        <div>{cellProps?.type || '-'}</div>
                    </div>
                )
            },
            minWidth: 150,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Offer name",
            columnID: "name",
            accessor: (cellProps) => {
                return (
                    <div>
                        <div className="text-bold d-flex">
                            {cellProps?.name || '-'}
                            <Label.StatusLabel label={cellProps?.status == 1 ? "active" : "inactive"} />
                        </div>
                        {
                            cellProps?.code && cellProps?.code !== "-" &&
                            <div>Code: <span className="text-bold" style={{ color: '#686868' }}>{cellProps.code}</span></div>
                        }
                        {
                            cellProps?.start &&
                            <div>Duration: {moment(cellProps?.start).format("DD MMM YYYY")} - {cellProps?.has_end_date === 1 ? `${moment(cellProps?.end).format("DD MMM YYYY")}` : "no end date"}</div>
                        }
                    </div>
                )
            },
            minWidth: 350,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Discount",
            columnID: "discount_value",
            accessor: (cellProps) => {
                return (
                    <div>{
                        cellProps?.discount_type === "Shipping" ?
                            `${cellProps?.is_percentage !== "Percentage" ? "S$" : ""}${cellProps?.discount_value}${cellProps?.is_percentage === "Percentage" ? "%" : ""} off on shipping` :
                            cellProps?.discount_type === "Product" && cellProps?.product_applicability_type === "products" ?
                                cellProps?.apply_to_all_product == 1 ?
                                    `${cellProps?.is_percentage !== "Percentage" ? "S$" : ""}${cellProps?.discount_value}${cellProps?.is_percentage === "Percentage" ? "%" : ""} off on all products` :
                                    `${cellProps?.is_percentage !== "Percentage" ? "S$" : ""}${cellProps?.discount_value}${cellProps?.is_percentage === "Percentage" ? "%" : ""} off on specific products`
                                :
                                cellProps?.apply_to_all_category == 1 ?
                                    `${cellProps?.is_percentage !== "Percentage" ? "S$" : ""}${cellProps?.discount_value}${cellProps?.is_percentage === "Percentage" ? "%" : ""} off on all categories` :
                                    `${cellProps?.is_percentage !== "Percentage" ? "S$" : ""}${cellProps?.discount_value}${cellProps?.is_percentage === "Percentage" ? "%" : ""} off on specific categories`
                    }</div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Usage count",
            columnID: "usage_count",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>{cellProps?.usage_count || '0'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Redemptions count",
            columnID: "redemption_count",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>{cellProps?.redemption_count || '0'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        }
    ]

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={10} md={12} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={promotionFilter || "0"}
                            onChange={(e) => { setPage("1"); setPromotionFilter(e) }}
                            data={promotionList}
                            placeholder={"Promotion types"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={discountFilter || "0"}
                            onChange={(e) => { setPage("1"); setDiscountFilter(e) }}
                            data={discountTargetList}
                            placeholder={"Discount targets"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={statusFilter || "0"}
                            onChange={(e) => { setPage("1"); setStatusFilter(e) }}
                            data={statusList}
                            placeholder={"Status"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content textColor">
                <LoadingDialog open={loading} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <DeleteModal setContent={setContent} content={content} />
                    <div className="header mb-2">Marketing Report</div>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={markettingReportListing?.data?.data || []}
                        getLengthPage={getLengthPage}
                        pageSize={length}
                        totalPage={markettingReportListing?.data?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={markettingReportListing?.data?.last_page || 1}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps({ Report, Login }) {
    return {
        markettingReportListing: Report.markettingReportListing,
        markettingReportDocument: Report.markettingReportDocument,
        userPermission: Login.permissionArry,

    };
}

export default connect(mapStateToProps)(MarketingReport);
